import axiosInstance from '@/shared/api/axios';
import type {
  ApiBroadcastPostBody,
  ApiBroadcastPostResponse,
} from '@/shared/types/api/broadcast';

export const apiBroadcastPost = async (
  body: ApiBroadcastPostBody,
): Promise<ApiBroadcastPostResponse> => {
  const form = new FormData();
  form.append('text_uz', body.text_uz);
  if (body.text_ru) form.append('text_ru', body.text_ru);
  if (body.text_en) form.append('text_en', body.text_en);
  if (body.text_kk) form.append('text_kk', body.text_kk);
  if (body.image) form.append('image', body.image);
  // Override the JSON default so the browser/axios sets the multipart boundary.
  const { data } = await axiosInstance.post<ApiBroadcastPostResponse>(
    '/notifications/broadcast',
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data;
};
